import { TSingleTabProps } from "@/app/types/types";
import CustomButton from "../CustomButton";

export default function SingleTab({ data, active, onClick , ref }: TSingleTabProps) {
	return (
		<CustomButton
			text={data?.title}
			style={active ? "white" : "masterPlanDark"}
			customClass={`${active ? "active" : ""}`}
			action={onClick}
			ref={ref}
		/>
	);
}
